import { Box, Button, Typography, Paper, Alert } from '@mui/material';

interface ErrorFallbackProps {
  error: Error;
  resetErrorBoundary: () => void;
}

export function ErrorFallback({
  error,
  resetErrorBoundary,
}: ErrorFallbackProps) {
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      minHeight="100vh"
      p={3}>
      <Paper
        elevation={3}
        sx={{
          p: 4,
          maxWidth: 600,
          width: '100%',
          textAlign: 'center',
        }}>
        <Alert severity="error" sx={{ mb: 3 }}>
          <Typography variant="h5" component="h1" gutterBottom>
            Something went wrong
          </Typography>
        </Alert>

        <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
          An unexpected error occurred. Please try again or contact support if
          the problem persists.
        </Typography>

        <Box sx={{ mb: 3, textAlign: 'left' }}>
          <Typography variant="subtitle2" color="text.secondary" gutterBottom>
            Error Details:
          </Typography>
          <Paper
            variant="outlined"
            sx={{
              p: 2,
              backgroundColor: 'grey.50',
              maxHeight: 200,
              overflow: 'auto',
            }}>
            <Typography variant="body2" component="pre" sx={{ margin: 0 }}>
              {error.message}
            </Typography>
          </Paper>
        </Box>

        <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center' }}>
          <Button
            variant="contained"
            onClick={resetErrorBoundary}
            color="primary">
            Try Again
          </Button>
          <Button
            variant="outlined"
            onClick={() => (window.location.href = '/')}>
            Go Home
          </Button>
        </Box>
      </Paper>
    </Box>
  );
}
